// @flow
import React from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from '../icons/loading/LoadingComponent';

import './LoadingComponent.scss';

type Props = {
  textLabel: string,
};

const LoadingComponent = ({ textLabel }: Props) => (
  <div className="loading-component">
    <div className="loading-component__container">
      <div className="loading-component__spinner">
        <LoadingIcon />
      </div>
      <div className="loading-component__label u-fontFamily-primaryMedium">{textLabel}</div>
    </div>
  </div>
);

LoadingComponent.displayName = 'Loading';

LoadingComponent.propTypes = {
  textLabel: PropTypes.string,
};

export default LoadingComponent;
